module.exports = __webpack_public_path__ + "static/img/sl-1.59b95ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/sl-1.png
// module id = u79u
// module chunks = 0